/* @ngInject */
function CampaignAccessController ($scope, $q, $state, GroupService, UdsModalService, ToastService, CampaignService) {
  const getNewGroupDialogController = () => $q.when(import('../../../admin/dialogs/new-group/new-group-dialog.controller'))
  $scope.top = 10
  $scope.skip = 0
  $scope.isCampaignActionsPublished = false
  $scope.selectedGroups = []
  $scope.filteredGroups = []
  $scope.groupsOptions = {
    top: 10,
    skip: 0,
    hasMoreOptions: false
  }

  const api = {
    getNewGroupDialogController,
    _getGroups,
    _handleSuccessGetGroups,
    _hasMoreResults,
    _getCampaignById
  }

  this.getApi = () => api

  activate()

  function activate () {
    if ($scope.campaign.id) {
      api._getCampaignById($scope.campaign.id)
    }
    api._getGroups()

    const deregisterFilteredGroupsWatcher = $scope.$watch('filteredGroups', function (newValue) {
      if (newValue && $scope.campaign.groupIds && $scope.campaign.groupIds.length > 0) {
        $scope.selectedGroups = $scope.campaign.groupIds.map(id => ({
          value: id,
          label: $scope.filteredGroups.find(group => group.value === id)?.label || ''
        }))
      }
    })

    $scope.$on('$destroy', () => {
      deregisterFilteredGroupsWatcher()
    })
  }

  function _getCampaignById (campaignId) {
    CampaignService.getCampaign(campaignId).then(response => {
      $scope.campaign.publicAccess = response?.groups?.length > 0 ? 'groupSegmentation' : 'allUsers'
      $scope.selectedGroups = response?.groups?.map(group => ({
        value: group.id,
        label: group.name
      }))
      $scope.isCampaignActionsPublished = response?.isActionsPublished
      $scope.$emit('campaign.access.isCampaignActionsPublished', $scope.isCampaignActionsPublished)
    })
  }

  function _getGroups (queryParams = {}) {
    const { top = $scope.groupsOptions.top, skip = $scope.groupsOptions.skip, search } = queryParams
    const params = search ? { searchTerm: search } : null
    GroupService.getGroups(top, skip, params, true).then(response => {
      api._handleSuccessGetGroups(response)
    })
  }

  function _handleSuccessGetGroups (response) {
    const groups = response.d.results
    const groupsRes = groups.map(group => ({
      label: group.name,
      value: group.id
    }))

    $scope.filteredGroups = [...groupsRes]
    $scope.groupsOptions.hasMoreOptions = api._hasMoreResults(groupsRes.length, response.d.__count)
  }

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }
    return responseLength > totalCount
  }

  $scope.onChangeSearchGroupsSelect = (event) => {
    const totalCount = event.detail?.totalCount
    const search = event.detail?.search || ''
    $scope.groupsOptions.skip = 0

    if (search === '') {
      api._getGroups({
        skip: $scope.groupsOptions.skip,
        top: $scope.groupsOptions.top
      })
    }

    api._getGroups({ totalCount, search })
  }

  $scope.onInfiniteGroups = (event) => {
    const totalCount = event.detail?.totalCount
    $scope.groupsOptions.skip = totalCount

    api._getGroups({ skip: $scope.groupsOptions.skip, top: $scope.groupsOptions.top })
  }

  $scope.onChangeGroupFilter = (event) => {
    const groupIds = event?.detail || []
    $scope.campaign.groupIds = groupIds.map(groupId => groupId.value)
  }

  $scope.createGroup = () => {
    api.getNewGroupDialogController().then(({ NewGroupDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: NewGroupDialogController,
        modalName: 'newGroupDialog',
        onClose: (bEmailSuccessfullySent) => {
          if (bEmailSuccessfullySent) {
            api._getGroups()
            ToastService.defaultSuccessToast()
          }
        }
      })
      modal.open()
    })
  }

  $scope.selectPublicAccess = event => {
    const radioName = event.detail.name
    const radioValue = event.detail.value
    $scope.campaign[radioName] = radioValue

    if (radioValue === 'allUsers') {
      $scope.selectedGroups = []
    }
  }

  $scope.goToGroups = () => {
    $scope.$parent.close()
    $state.go('admin.groups')
  }
}

export { CampaignAccessController }
